export default __webpack_public_path__ + "static/media/w3.b71639b7.jpg";